module.exports = __webpack_public_path__ + "img/hero.660b4e34.png";